import { render } from "./Graduates.vue?vue&type=template&id=1b6b17c2"
import script from "./Graduates.vue?vue&type=script&lang=js"
export * from "./Graduates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__